import React, { Component } from 'react'
import Wix from 'Wix';
import { connect } from 'react-redux';
import './settings.scss';
import GdUnitControlPanel from './Containers/gdUnitControlPanel/gdUnitControlPanel';
// actions
import setDataPublic from '../actions/dataPublicActions';
import {setLayoutFile, setLayoutFolder, setDisplayLastModified, setDisplayOwner, setSortDefault} from '../actions/updateConnectActions';


class Settings extends Component {

    componentDidMount() {
        const compId = Wix.Utils.getOrigCompId();
        const instanceId = Wix.Utils.getInstanceId();    
        window.localStorage.removeItem('token');    
        let datapublicObj = { 'compId': compId, "instanceId": instanceId };
        this.props.setDataPublic(datapublicObj);

        Wix.Styles.getStyleParams(style => {
            if (style.booleans)
            {
                if(typeof style.booleans.displayLastModified !== "undefined") {
                    this.props.setDisplayLastModified(style.booleans.displayLastModified)
                }           
                if(typeof style.booleans.displayOwner !== "undefined") {
                    this.props.setDisplayOwner(style.booleans.displayOwner)
                }
            }
            if (style.numbers) {
                if (style.numbers.select_layout)
                    this.props.setLayoutFolder(style.numbers.select_layout);
                if (style.numbers.layout_file)
                    this.props.setLayoutFile(style.numbers.layout_file)
                if (style.numbers.select_sort)
                    this.props.setSortDefault(style.numbers.select_sort)
                }    
        });
    }

    render() {
        return (
            <GdUnitControlPanel />
        )
    }
}

const mapStateToProps = state => ({
    dataPublic: state.dataPublicReducer.dataPublic,
    showBtn: state.userConnectReducer.showBtn,

})

const mapDispatchToProps = dispatch => ({
    setLayoutFile: (layout_file) => dispatch(setLayoutFile(layout_file)),
    setLayoutFolder: (select_layout) => dispatch(setLayoutFolder(select_layout)),
    setDataPublic: (datapublicObj) => dispatch(setDataPublic(datapublicObj)),
    setDisplayLastModified: (displayLastModified) => dispatch(setDisplayLastModified(displayLastModified)),
    setDisplayOwner: (displayOwner) => dispatch(setDisplayOwner(displayOwner)),
    setSortDefault: (sortDefault) => dispatch(setSortDefault(sortDefault))
})

export default connect(mapStateToProps, mapDispatchToProps)(Settings);


// WEBPACK FOOTER //
// ./src/settings/settings.js